import {
    CCPPricingPlanContent,
    CCPPricingPlanItem,
    CCPPricingPlanTier
} from "src/contentful/product-catalog";

import {
    PricingPlans,
    PricingStrategy,
    PricingStrategyValue,
    PricingTier
} from "../constants";

// CCP Amounts are stored in cents - Note: JPY needs no conversion
const formatCentsToDollars = (value: number, currency: string): number => {
    if (currency === "USD" && value) {
        return value / 100;
    }
    return value;
};

const convertCCPTiersToHAMS = (
    ccpTiers: CCPPricingPlanTier[],
    chargeElement: string,
    currency: "USD" | "JPY"
): PricingTier[] =>
    ccpTiers.map((ccpTier) => {
        let pricingStrategy: PricingStrategyValue =
            PricingStrategy.MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = PricingStrategy.FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency,
                    unitPrice: formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });

export type GetCcpTiers = (
    pricingPlans: CCPPricingPlanContent
) => CCPPricingPlanItem;

export const convertCCPPricingPlansToHAMS = (
    pricingPlans: CCPPricingPlanContent[],
    currencyISOCode: string,
    getCcpTiers?: GetCcpTiers
): PricingPlans => {
    const [monthlyCCP, annualCCP] = ["MONTH", "YEAR"].map((primaryCycle) =>
        // Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find(
            (pricingPlan) =>
                pricingPlan.primaryCycle_interval === primaryCycle &&
                pricingPlan.type === "COMMERCIAL" &&
                pricingPlan.activatedWithReason === "DEFAULT_PRICING" &&
                // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
                // If needed, can filter by USD only which we will pass in directly in those components
                pricingPlan.currency === currencyISOCode
        )
    );

    const [monthly, annual] = [monthlyCCP, annualCCP].map((ccpContent) => {
        if (!ccpContent) {
            return undefined;
        }

        const ccpTiers = getCcpTiers
            ? getCcpTiers(ccpContent)
            : (ccpContent.items[0] as CCPPricingPlanItem);
        const { tiers, chargeElement } = ccpTiers;

        return convertCCPTiersToHAMS(
            tiers,
            chargeElement,
            ccpContent.currency as "USD" | "JPY"
        );
    });

    return {
        monthly,
        annual
    };
};
